import * as Yup from "yup"

export default function validation_staff_notes(field, acc, editMode) {
  const { field_name } = field
  return {
    [field_name]: Yup.array().of(
      Yup.object().shape({
        staff_note__staff_id_selector: Yup.object().shape({
          key: Yup.string()
            .required("You must select a staff.")
            .min(3, "Please assign a staff."),
        }),
      })
    ),
    ...acc,
  }
}
